import styled from 'styled-components';

export const NoDataFoundStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding: 35px;
    color: ${({ theme }) => theme.branding.gray.dark};
    font-size: 15px;
    background-color: ${({ theme }) => theme.branding.white.main};
    box-shadow: none;
    border-radius: 8px;
    border: 1px solid rgb(223, 224, 235);
    > span {
        margin-left: 3px;
    }
`;
